module.exports = {
      id: "phone-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#phone",
      toString: function () {
        return this.url;
      }
    }